import Auth from '@aws-amplify/auth';
import ApolloClient from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { split } from 'apollo-link';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import gql from 'graphql-tag';

import awsConfig from '../aws-exports';

const { api_url, notifications_api_url } = awsConfig;

const setAuthorizationLink = setContext(async () => {
	try {
		const currentSession = await Auth.currentSession();
		const jwtToken = currentSession.getIdToken().getJwtToken();
		return {
			headers: { authorization: `Bearer ${jwtToken}` }
		};
	} catch (err) {
		console.error('Getting token failed', err);
	}
});

const client = new ApolloClient({
	link: split(
		(operation) => operation.getContext().api === 'notifications',
		setAuthorizationLink.concat(createHttpLink({ uri: notifications_api_url })),
		setAuthorizationLink.concat(createHttpLink({ uri: api_url }))
	),
	cache: new InMemoryCache({
		typePolicies: {
			Airing: {
				keyFields: ['id'] // workaround as set as string type on API not ID type
			}
		},
		fragmentMatcher: new IntrospectionFragmentMatcher({
			introspectionQueryResultData: {
				__schema: {
					types: [
						{
							kind: 'UNION',
							name: 'listFerOutput',
							possibleTypes: [
								{
									name: 'Game'
								},
								{
									name: 'Fer'
								}
							]
						}
					]
				}
			}
		})
	}),
	typeDefs: gql`
		enum SortDirection {
			ASC
			DESC
		}

		input StringFilterInput {
			ne: String
			eq: String
			le: String
			lt: String
			ge: String
			gt: String
			contains: String
			notContains: String
			between: [String]
			beginsWith: String
		}

		input HighlightFilterInput {
			type: StringFilterInput

			and: [HighlightFilterInput]
			or: [HighlightFilterInput]
			not: HighlightFilterInput
		}
	`
});

export default client;
